export default __webpack_public_path__ + "static/media/icon_web3js.d61f41c7.jpg";